<template>
<div>
  <div v-if="isLoading">
    <v-progress-linear
      indeterminate
      color="primary"
      ></v-progress-linear>
  </div>
  <v-container fluid>
    <v-row>
        <v-col sm="12" md="6" cols="12" >
            <search-bar
                v-model="query.search"
                v-on:clear="clearSearch"
                :label="searchLabel"
                v-on:request-search="onRequestSearch"
            />
        </v-col>
        <v-col cols="12" sm="12" md="6">
            <sort-bar
                v-model="query.sort"
                v-bind:items="sortItems"
                v-on:request-sort="onRequestSort"
            />
        </v-col>

    </v-row>
  </v-container>
  <v-pagination
    v-if="this.pagination != undefined && this.pagination.totalItems > 0"
    v-model="pagination.currentPage"
    v-bind:length="pagination.pageCount"
    v-on:input = "onRequestPageChange"
    circle
  ></v-pagination>
  <div v-if="!isLoading">
    <v-row class="ma-1">
      <v-col
        v-if="writers.length<=0"
      >
        <v-banner
          single-line
          class="text-h6"
        >
          No records
        </v-banner>
      </v-col>
      <v-col
        sm="12" md="6"
        v-for="item in writers"
        :key="item.id"
        class="d-flex child-flex"
      >
          <guest-writer :data="item" @delete_success="deleteSuccessCallback"/>
      </v-col>
    </v-row>
  </div>
</div>
</template>

<script>
import gwApi from '@/api/gwApi'
// import snackbar from '@/utils/snackbar'
export default {
  components: {
    'search-bar': () => import('@/components/SearchBar'),
    'sort-bar': () => import('@/components/SortBar'),
    'guest-writer': () => import('@/components/GuestWriterCard')
  },
  mounted () {
    this.fetchGuestWriter()
  },

  data: function () {
    return {
      query: {
        search: null,
        sort: null,
        page: 1,
        item_per_page: 16
      },
      searchLabel: 'Search for name or address',
      pagination: {
        currentPage: 1,
        pageItemFrom: 0,
        pageItemTo: 0,
        totalItems: 0,
        pageCount: 0
      },
      writers: [],
      isLoading: false,
      sortItems: [
        { text: 'Newest first', value: 'created_at:desc' },
        { text: 'Oldest first', value: 'created_at:asc' }
      ]
    }
  },
  methods: {
    deleteSuccessCallback () {
      this.fetchGuestWriter()
    },
    async fetchGuestWriter () {
      try {
        this.isLoading = true
        const response = await gwApi.getGuestWriters(this.query)
        this.parsePaginationData(response.data)
        this.writers = response.data.data
      } finally {
        this.isLoading = false
      }
    },
    onRequestSort () {
      this.fetchGuestWriter()
    },
    onRequestSearch () {
      this.fetchGuestWriter()
    },
    clearSearch () {
      this.query.search = null
      this.fetchGuestWriter()
    },
    parsePaginationData (pagination) {
      this.pagination.currentPage = pagination.current_page
      this.pagination.totalItems = pagination.total
      this.pagination.pageItemFrom = pagination.from
      this.pagination.pageItemTo = pagination.to
      this.pagination.pageCount = pagination.last_page
    },
    onRequestPageChange (pageNo) {
      this.query.page = pageNo
      this.fetchGuestWriter()
    }

  }
}
</script>
